// extracted by mini-css-extract-plugin
export default {"form":"EditFolder_form__ty3jp","btnsContainer":"EditFolder_btnsContainer__R-C9W"};